import axios from 'lib/apiClient';

export const login = async (username, password, device_id) => {
  return axios.post('API/1_0/postLogin.php', {
    username,
    password,
    device_id,
    // is_mobile: remember ? '1' : null,
  });
};

export const loginWithToken = async (token) => {
  return axios.post('API/1_0/postLogin.php', {
    user_token: token,
  });
};

export const verifyCode = (username, code, deviceId) => {
  return axios.post('API/1_0/postLogin.php', {
    username,
    verify_code: code,
    device_id: deviceId,
  });
};

export const sessionReset = (account_id) =>
  axios.post('API/1_0/sessionReset.php', { account_id });

export const resendVerificationCode = (username, deviceId) =>
  axios.post('API/1_0/postResendVerification.php', {
    username,
    device_id: deviceId,
  });

export const getAuthApp = (client_id) =>
  axios
    .get('API/1_0/oauthApps.php', { params: { client_id, account_id: 0 } })
    .then((r) => r[0]);

export const oauthorize = (data) => axios.post('API/1_0/oauthorize.php', data);
